var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-block px-4 py-1 font-semibold rounded-full",class:_vm.statusClass,domProps:{"innerHTML":_vm._s(_vm.statusText)}})
}
var staticRenderFns = []

export { render, staticRenderFns }